<template>
  <div>
    <v-card outlined class="white" :elevation="5">
      <v-chart
        :option="polar"
        autoresize
        :style="{ height: '300px', width: '100%' }"
      />
    </v-card>
  </div>
</template>

<script>
import Moment from 'moment'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { HeatmapChart, LineChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  VisualMapComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import variables from '@/styles/variables.scss'

use([
  CanvasRenderer,
  HeatmapChart,
  LineChart,
  GridComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent
])

export default {
  components: {
    VChart
  },
  props: {
    title: String,
    color: Array,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    data: Array,
    xAxis: Array,
    yAxis: Array,
    type: String
  },
  watch: {
    data: {
      handler(newOptionValue) {
        this.chart()
      }
    }
  },
  data() {
    return {
      polar: {}
    }
  },
  methods: {
    chart() {
      this.polar = {
        textStyle: {
          fontFamily: variables.fontFamily
        },
        title: {
          text: this.title,
          left: '20',
          top: '10px'
        },
        tooltip: {
          formatter: params => {
            const data = params.data

            const time = data[0]
            const day = Moment()
              .day(data[1])
              .format('dddd')
            const value = data[2]

            const unit = this.type === 'voice' ? 'calls' : 'chats'

            const start = `${('0' + time).slice(-2)}:00`
            const end = `${('0' + parseInt(time + 1)).slice(-2)}:00`

            return `${value.toLocaleString()} ${unit} on ${day} from ${start} to ${end}`
          }
        },
        animation: false,
        grid: {
          left: '10%'
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          data: this.yAxis,
          splitArea: {
            show: true
          },
          inverse: true
        },
        visualMap: {
          min: this.min,
          max: this.max,
          inRange: {
            color: this.color
          },
          calculable: true,
          show: false
        },
        series: [
          {
            name: this.title,
            type: 'heatmap',
            data: this.data,
            label: {
              show: true,
              formatter: params => {
                const val = params.value[2]
                if (val >= 1000) return `${parseFloat(val / 1000).toFixed(1)}K`
                else return val
                // return `${params.value[2].toLocaleString()}`
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  }
}
</script>
